/**
 * Vuex
 *
 * Vuex is a state management pattern + library for Vue.js applications. It
 * serves as a centralized store for all the components in an application, with
 * rules ensuring that the state can only be mutated in a predictable fashion.
 *
 * https://vuex.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import actions from './actions';
import getters from './getters';
import modules from './modules';
import mutations from './mutations';
import state from './state';
import persistedState from './persistedState';

Vue.use(Vuex);

// Create a new store
const store = new Vuex.Store({
	actions,
	getters,
	modules,
	mutations,
	state,
	plugins: [createPersistedState(persistedState)],
});

export default store;
